import { fetchApi } from "./fetchApi";

export const autoAssignmentApi = {
  async get() {
    const response = await fetchApi({
      method: "GET",
      url: "/api/serviceArea/autoAssignment",
    });

    return response;
  },
  async put(data) {
    await fetchApi({
      method: "PUT",
      url: "/api/serviceArea/autoAssignment",
      data,
    });
  },
  async runOnDemand(packId: number) {
    return fetchApi({ method: "POST", url: `/api/pack/${packId}/autoAssignment/run` });
  },
  async getRunHistory(packId: number) {
    return fetchApi({ method: "GET", url: `/api/auditLog/autoAssignment/pack/${packId}` });
  },
};
